module.exports = __webpack_public_path__ + "static/img/cars-bg.5a39dfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cars-bg.jpg
// module id = DQJ+
// module chunks = 1